import { RADashboardPortfolioType } from '@/constants/ReportDashboard/asset-enums'
import DefaultDashboardFixedIncome from '@/constants/ReportDashboard/dashboards/defaultFixedIncome'
import { RADashboardLayout } from '@/interfaces/raDashboard.interface'
import React, { PropsWithChildren } from 'react'

export interface RADashboardLayoutInformation {
  layout: RADashboardLayout,
  assetClass: RADashboardPortfolioType | null
}

const initialValue: RADashboardLayoutInformation = {
  layout: DefaultDashboardFixedIncome,
  assetClass: null
}

export const RADashboardLayoutContext = React.createContext(initialValue)

export default function RADashboardLayoutContextProvider(
  props: PropsWithChildren<RADashboardLayoutInformation>,
) {
  const { layout, assetClass } = props;
  const layoutInfo = {
    layout, assetClass
  }
  return (
    <RADashboardLayoutContext.Provider value={layoutInfo}>
      {props.children}
    </RADashboardLayoutContext.Provider>
  )
}
